import React, { useEffect, useState, useTransition } from 'react';
import { AppInterface, MessageSenderDialog, PeerProfile_Internal_Dialog, RecordsPagination, ThemedButton, ThemedIconButton } from "../../index";
import { GenRouteUrls, Keys, ModuleFieldsData, ModuleRouteUrls, Modules, ReqUrls } from "../../config/AppConfig";
import { useTheme } from "../../../common/ProjectThemeProvider";
import {
    checkNullArr,
    checkNullJson,
    checkNullStr,
    concatStrings,
    getArrLen,
    getJsonValue,
    getDefStr,
    getJsonValueFromNestedKeys,
    isBoolTrue,
    isJsonValueTrue,
    setTabTitle,
    shuffleList,
    trim
} from "../../../common/fusion-ui/utils/ReactUtils";
import { getAllocatedModuleName, getUserSessionField, isModuleAllocated, printError, printLog, sendRequest } from "../../utils/AppUtils";
import { useToast } from "../../../common/fusion-ui/provider/ToastProvider";
import { Anchor, Avatar, CircleLoading, Flexbox, GridBox, Label, LoadingSection, NullMsgLabel, Section } from "../../../common/fusion-ui"
import { CssVariant, DefStrNA, Messages } from 'common/fusion-ui/config/FusionConfig';
import useScreenSize from "../../../common/fusion-ui/hook/useScreenSize";
import { useConfig } from "../../context/ConfigProvider";
import { AnimationType, FramerAnimator } from "../../../common/fusion-ui/animation/FramerAnimator";
import { margin, width } from '@mui/system';

const PeerProfilesPage = React.memo(({
    fromSearchPage = false, recordList, showControls = true,
}) => {
    const TAG = "PeerProfilesPage";

    const moduleName = Modules.PeerProfiles;
    const mf_pp = ModuleFieldsData[Modules.PeerProfiles];
    const mf_up = ModuleFieldsData[Modules.UserProfile];

    const theme = useTheme();
    const { showToast, changeToastVariant } = useToast();
    const { isConfigTrue, updateConfig } = useConfig();
    const { isScreenUpSm, isScreenXs, isScreenSm, isScreenMd, isScreenLg, isScreenXl, isScreenResizing } = useScreenSize();

    const animator = new FramerAnimator();

    const PAGINATION_RECORD_LIMITS = [9, 12, 15, 18];
    const DEF_PGNTN_RECORD_LIMIT = PAGINATION_RECORD_LIMITS[1];
    const DEF_PGNTN_START_INDEX = 1;

    const Fields = {
        recordList: `${TAG}_recordList`, profileData: 'profileData',

        isDataLoading: 'isDataLoading', isDataFound: 'isDataFound', dataLoadingMsg: 'dataLoadingMsg', isDataFetched: 'isDataFetched',

        currRecordItem: 'currRecordItem', currRecordId: 'currRecordId', openProfileDetailsDialog: 'openProfileDetailsDialog', openSendMsgDialog: 'openSendMsgDialog',

        messageDialog_clearData: 'messageDialog_clearData',

        pagination_currPageNum: 'pagination_currPageNum', pagination_currPageLimit: 'pagination_currPageLimit',

        alphabeticPagination_currGroupId: 'alphabeticPagination_currGroupId',

        recordMail_submitBtn_AsLoading: 'recordMail_submitBtn_AsLoading', recordMail_submitBtn_disabled: 'recordMail_submitBtn_disabled',
    };
    const [fieldsData, setFieldsData] = useState({
        [Fields.isDataLoading]: true,
    });
    const AlphabeticGroups = {
        // all: {id: 'all', value: 'All'},
        aToD: { id: 'aToD', values: ['A', 'B', 'C', 'D'] },
        eToH: { id: 'eToH', values: ['E', 'F', 'G', 'H'] },
        iToL: { id: 'iToL', values: ['I', 'J', 'K', 'L'] },
        mToP: { id: 'mToP', values: ['M', 'N', 'O', 'P'] },
        qToT: { id: 'qToT', values: ['Q', 'R', 'S', 'T'] },
        uToZ: { id: 'uToZ', values: ['U', 'V', 'W', 'X', 'Y', 'Z'] },
    };
    const [alphabeticPgntnChangePending, startAlphabeticPgntnChangeTransition] = useTransition();


    useEffect(() => {
        if (!isBoolTrue(fromSearchPage)) {
            setTabTitle(getAllocatedModuleName(moduleName));
            updateConfig(Keys.config_ShowTabBar, true);
            updateConfig(Keys.config_TabBarTab, -1);
            updateConfig(Keys.config_navbarCurrPage, moduleName);
            updateConfig(Keys.tracker_currPageModule, moduleName);
            updateConfig(Keys.tracker_currPageTag, TAG);
        }
    }, [fromSearchPage]);

    useEffect(() => {
        if (!checkNullStr(getField(Fields.pagination_currPageNum))) {
            updateField(Fields.pagination_currPageNum, DEF_PGNTN_START_INDEX);
            updateField(Fields.pagination_currPageLimit, DEF_PGNTN_RECORD_LIMIT);
        }
        if (isBoolTrue(fromSearchPage)) {
            if (!isFieldTrue(Fields.isDataFetched)) {
                updateField(Fields.isDataFetched, true);
                const success = checkNullArr(recordList);
                updateField(Fields.recordList, recordList);
                updateField(Fields.isDataLoading, false);
                updateField(Fields.isDataFound, success);
                updateField(Fields.dataLoadingMsg, success ? '' : Messages.noDataFound);
                // log('useEffect.recordList:', recordList, 'found:', checkNullArr(recordList));
            }
        } else {
            fetchPageData();
        }
    }, [fromSearchPage, recordList]);

    useEffect(() => {
        if (alphabeticPgntnChangePending) handleRecordVisLimitChange(getField(Fields.pagination_currPageLimit));
    }, [alphabeticPgntnChangePending]);

    return (<>
        {isBoolTrue(fromSearchPage) ? createRecordListPanel() : createPage()}
        {createProfileDetailsDialog()}
        {isBoolTrue(showControls) && createSendMsgDialog()}
    </>);

    function createPage() {
        return <>
            <AppInterface label={moduleName}>
                <div className={''}>
                    {<LoadingSection
                        labelClassName={'m-2 w-100 fs-normal'}
                        heightClass={75}
                        color={theme.text70}
                        success={isFieldTrue(Fields.isDataFound)}
                        loading={isFieldTrue(Fields.isDataLoading)}
                        msg={getField(Fields.dataLoadingMsg)}
                    />}

                    {(!isFieldTrue(Fields.isDataLoading) && isFieldTrue(Fields.isDataFound)) && <div className={'m-0 p-0 w-100 h-100 position-relative'}>
                        {/*header*/}
                        {/* Updated by Vandit Tewari (28/10/24) - the left and right section overlaping so done this so both come in diffrent row give direction argument to GridBox and also set md = 12 instead of 6 to take them full space*/}
                        {animator.setAnimationType(AnimationType.SLIDE_DOWN).render(<GridBox className={'m-0 p-0 w-100 al-center al-start-sm'}
                            sm={12} md={[12, 12]} gap={0} direction={window.innerWidth < 1175 ? 'column' : 'row'}>
                            {/*left*/}
                            {/* Updated by Vandit Tewari (28/10/24) - passed 2 more arguments to Flexbox are directionSm, justifyAtSm, alignAtSm done this to stop overflow of 2 contol button out of scrren they come below profile */}
                            {!isBoolTrue(fromSearchPage) && <Flexbox className={'m-0 p-0'}
                                justifyAt={'start'} alignAt={'center'} directionSm='column' gap='.5vh' justifyAtSm='center' alignAtSm='center'
                            >
                                {/*admin-card*/}
                                <Flexbox className={'px-2 py-1 rounded-3'}
                                    justifyAt={'start'}
                                    alignAt={'center'}
                                    bg={theme.primaryBlue10}
                                >
                                    {/*img*/}
                                    <div className={'m-0 p-0 ps-1'}>
                                        <Avatar
                                            wrapperClassName={'m-0 p-0'}
                                            imgClassName={'rounded-3'}
                                            size={'50px'}
                                            circular={true}
                                            bordered={true}
                                            showFullPreviewDialog={true}
                                            showInitials={true}
                                            nameForInitials={getJsonValue(getProfileData(), mf_pp.name.column)}
                                        >
                                            {getJsonValue(getProfileData(), mf_pp.image.column)}
                                        </Avatar>
                                    </div>

                                    {/* texts */}
                                    <div className={'px-2'}>
                                        <Anchor
                                            className={'m-0 p-0 mt-2x mb-n1 text-nowrap fw-bold fs-sm-md bg-dangerx'}
                                            href={ModuleRouteUrls[Modules.UserProfile]}>
                                            {getJsonValue(getProfileData(), mf_pp.name.column, DefStrNA)}
                                        </Anchor>

                                        {/* bio */}
                                        <Label className={'p-0 text-nowrap m-0 p-0'} textAt={'start'} color={theme.text}>
                                            {getJsonValue(getProfileData(), mf_pp.role.column, DefStrNA)}
                                        </Label>
                                    </div>
                                </Flexbox>

                                {/*controls*/}
                                <Flexbox className={'m-0 p-0 mx-1'}
                                    justifyAt={'start'} alignAt={'start'}
                                    justifyAtSm={'start'} wrapSm={'wrap'} directionSm={'column'}
                                >
                                    {/*MyParticipations*/}
                                    {(isModuleAllocated(Modules.MyParticipations)) && <ThemedButton
                                        className={'fs-sm fw-semi-bold text-nowrap'}
                                        outlined={true}
                                        sleek={true}
                                        m={1}
                                        height={'28px'}
                                        text={`${Modules.MyParticipations}`}
                                        href={ModuleRouteUrls[Modules.MyParticipations]}
                                        variant={theme.primaryBlue}
                                    />}

                                    {/*RecommendPeer*/}
                                    {(isModuleAllocated(moduleName) && isModuleAllocated(Modules.RecommendPeer)) && <ThemedButton
                                        className={'fs-sm fw-semi-bold text-nowrap'}
                                        outlined={true}
                                        sleek={true}
                                        m={1}
                                        height={'28px'}
                                        text={`Recommend a Peer`}
                                        href={GenRouteUrls.recom_PeerPage}
                                        variant={theme.primaryBlue}
                                    />}
                                </Flexbox>
                            </Flexbox>}

                            {/*right - alph-pagination*/}
                            <div className={' d-flex jc-end jc-start-md jc-start-sm fd-row flex-nowrap my-1'}>
                                <Flexbox className={'p-1 px-2 w-auto scroller scroller-x-auto rounded-3'}
                                    justifyAt={'end'} justifyAtSm={'start'} alignAt={'center'} borderVariant={0}
                                    style={{ borderColor: theme.primaryBlueDark50 }}>
                                    {(alphabeticPgntnChangePending && (!isScreenXs && !isScreenSm)) && <div>
                                        <CircleLoading wrapperHeight={'auto'} size={'20px'} borderWidth={'3px'} />
                                    </div>}

                                    {/*all*/}
                                    {/* Update by vandit tewari (28/10/24) - from below div removed class mt-1 bcz the filter named all is comeing down then other options */}
                                    <div className={'m-0 p-1'}>
                                        <ThemedButton
                                            className={'text-nowrap px-2 fw-semi-bold fs-sm'}
                                            text={`All`}
                                            outlined={true}
                                            // Update by vandit tewari (28/10/24) - from below  below m pass 0 instead of 1 to set all button with outhers
                                            m={0}
                                            width={'auto'}
                                            height={'20px'}
                                            variant={'x'}
                                            bgColor={!checkNullStr(getField(Fields.alphabeticPagination_currGroupId)) ? theme.primaryBlueDark : null}
                                            hoverBgColor={!checkNullStr(getField(Fields.alphabeticPagination_currGroupId)) ? theme.primaryBlueDark : theme.primaryBlue}
                                            color={!checkNullStr(getField(Fields.alphabeticPagination_currGroupId)) ? theme.textWhite : theme.primaryBlueDark}
                                            borderColor={theme.primaryBlueDark}
                                            enableFocusStyling={false}
                                            onClick={() => {
                                                startAlphabeticPgntnChangeTransition(() => {
                                                    updateField(Fields.alphabeticPagination_currGroupId, null);
                                                });
                                            }}
                                        />
                                    </div>

                                    {/*groups*/}
                                    {Object.values(AlphabeticGroups).map((item, index) => {
                                        return <div key={index + 'mkuy'} className={'m-0 p-1'}>
                                            <ThemedButton
                                                className={'text-nowrap px-2 fw-semi-bold fs-sm'}
                                                // text={`${item.values[0]} -> ${item.values[item.values.length - 1]}`}
                                                text={`${item.values[0]}-${item.values[item.values.length - 1]}`}
                                                outlined={true}
                                                width={'auto'}
                                                height={'20px'}
                                                variant={'x'}
                                                bgColor={getField(Fields.alphabeticPagination_currGroupId) == item.id ? theme.primaryBlueDark : null}
                                                hoverBgColor={getField(Fields.alphabeticPagination_currGroupId) == item.id ? theme.primaryBlueDark : theme.primaryBlue}
                                                color={getField(Fields.alphabeticPagination_currGroupId) == item.id ? theme.textWhite : theme.primaryBlueDark}
                                                borderColor={theme.primaryBlueDark}
                                                enableFocusStyling={false}
                                                onClick={() => handleAlphabeticPgntnBtnClick(item)}
                                            />
                                        </div>
                                    })}

                                    {(alphabeticPgntnChangePending && (isScreenXs || isScreenSm)) && <div className={'mt-1'}>
                                        <CircleLoading wrapperHeight={'auto'} size={'20px'} borderWidth={'3px'} />
                                    </div>}
                                </Flexbox>
                            </div>
                        </GridBox>)}

                        {createRecordListPanel()}
                    </div>}
                </div>
            </AppInterface>
        </>
    }

    function createRecordListPanel() {
        return <div>
            {/* record-list */}
            {(!isFieldTrue(Fields.isDataLoading)) && <div className={'w-100 px-1 mt-1'}>
                {checkNullArr(getRecordListToRender()) ? <GridBox className={'px-1'} sm={12} md={6} gap={1} justifyAt={'start'}>
                    {getRecordListToRender().map((item, index) => {
                        const recordId = getJsonValue(item, mf_up.memberId.column);
                        return animator.setAnimationType(AnimationType.SLIDE_UP).setDelay(100 * index).render(<Section
                            key={index + getJsonValue(item, mf_up.fullName.column)}
                            className={'m-0 p-1 h-100 app-section hover'}
                            borderless={false}
                            roundedVariant={4}
                            borderColor={theme.text20}>
                            <Flexbox className={''}
                                justifyAt={'between'}
                                alignAt={'center'}>
                                {/* left - img & texts */}
                                <Flexbox className={''} key={index}
                                    justifyAt={'start'}
                                    alignAt={'center'}>
                                    {/* img */}
                                    <div className={'m-0 p-0 ps-1 pt-1'}>
                                        <Avatar
                                            wrapperClassName={'m-0 p-0'}
                                            imgClassName={'rounded-3'}
                                            size={'60px'}
                                            circular={false}
                                            bordered={false}
                                            showInitials={true}
                                            showFullPreviewDialog={true}
                                            nameForInitials={getJsonValue(item, mf_up.fullName.column)}>
                                            {getJsonValue(item, mf_up.memberImage.column)}
                                        </Avatar>
                                    </div>
                                    <div className={'p-0 m-0 ps-2'}>
                                        {/* name */}
                                        <div className={'w-auto d-flex'}>
                                            <Anchor
                                                wrapperClassName={'w-auto'}
                                                className={'fw-semi-bold m-0 p-0 text-wrap'}
                                                simple={true}
                                                href={`${GenRouteUrls.pp_internalPage}${recordId}`}
                                                onClick={(e) => {
                                                    if (!isScreenUpSm) {
                                                        e.preventDefault();
                                                        if (e.ctrlKey) {
                                                            window.open(`${GenRouteUrls.pp_internalPage}${recordId}`, '_blank');
                                                        } else {
                                                            updateField(Fields.currRecordId, recordId);
                                                            updateField(Fields.openProfileDetailsDialog, true);
                                                        }
                                                    }
                                                }}>
                                                {getJsonValue(item, mf_up.fullName.column, DefStrNA)}
                                            </Anchor>
                                        </div>

                                        {/* bio */}
                                        <div className={'m-0 p-0 text-wrap d-flex jc-start'}>
                                            {concatStrings([getJsonValue(item, mf_up.memberOrganisation1.column, getJsonValue(item, mf_up.memberOrganisation2.column, DefStrNA)), getJsonValue(item, mf_up.cityName.column)], ', ', DefStrNA)}
                                        </div>
                                    </div>
                                </Flexbox>

                                {/* right -  email-icon */}
                                {isBoolTrue(showControls) && <div
                                    className={'m-0 p-1 px-2 bg-dangerx'}>
                                    <ThemedIconButton
                                        className={'mx-2x px-1 py-1 w-2'}
                                        mx={1}
                                        icon={'bi bi-envelope-fill'}
                                        tooltip={'Send Message'}
                                        color={theme.primaryBlue}
                                        outlined={true}
                                        bgColor={theme.textWhite}
                                        hoverBgColor={theme.primaryBlue}
                                        borderColor={theme.primaryBlue}
                                        size={'26px'}
                                        onClick={() => {
                                            updateField(Fields.currRecordItem, {
                                                ...item,
                                                id: recordId,
                                                name: getJsonValue(item, mf_up.fullName.column, DefStrNA),
                                                email: getJsonValue(item, mf_up.username.column, DefStrNA),
                                                selected: true,
                                            });
                                            updateField(Fields.currRecordId, recordId);
                                            updateField(Fields.openSendMsgDialog, true);
                                        }}
                                    />
                                </div>}
                            </Flexbox>
                        </Section>, { className: 'h-100' })
                    })}
                </GridBox> : (!alphabeticPgntnChangePending) && <NullMsgLabel className={'w-100'} color={theme.text80} textAt={'center'}>
                    No profiles found!
                </NullMsgLabel>}
            </div>}

            {/* pagination */}
            <RecordsPagination
                id={TAG}
                show={!isFieldTrue(Fields.isDataLoading)}
                currPage={getField(Fields.pagination_currPageNum)}
                currPageRecordLimit={getField(Fields.pagination_currPageLimit)}
                totalRecords={getArrLen(getRecordList(true))}
                totalRecordsToRender={getArrLen(getRecordListToRender())}
                recordLimits={PAGINATION_RECORD_LIMITS}
                onPageChange={(e, newPageIndex) => {
                    // log('RecordsPagination.onLimitChange.newPageIndex:', newPageIndex);
                    updateField(Fields.pagination_currPageNum, newPageIndex);
                }}
                onLimitChange={(newLimit, newPageIndex) => {
                    // log('RecordsPagination.onLimitChange.newLimit:', newLimit, 'newPageIndex:', newPageIndex);
                    updateField(Fields.pagination_currPageLimit, newLimit);
                    updateField(Fields.pagination_currPageNum, newPageIndex);
                }}
            />
        </div>
    }

    function createProfileDetailsDialog() {
        return <PeerProfile_Internal_Dialog
            recordId={getField(Fields.currRecordId)}
            open={isFieldTrue(Fields.openProfileDetailsDialog)}
            asDrawer={true}
            onHide={() => {
                updateField(Fields.openProfileDetailsDialog, false);
                updateField(Fields.currRecordId, null);
            }}
        />
    }

    function createSendMsgDialog() {
        return <MessageSenderDialog
            open={isFieldTrue(Fields.openSendMsgDialog)}
            recordId={getField(Fields.currRecordId)}
            replyMode={false}
            clearData={isFieldTrue(Fields.messageDialog_clearData)}
            recipientNameAsEmail={false}
            asDrawer={true}
            disableSubmit={isFieldTrue(Fields.recordMail_submitBtn_disabled)}
            loadingSubmit={isFieldTrue(Fields.recordMail_submitBtn_AsLoading)}
            selectedRecipients={[getField(Fields.currRecordItem)]}
            onSubmit={handleRecordMsgSubmit}
            onHide={handleClose}
            onCancel={handleClose}
        />

        function handleClose() {
            updateField(Fields.openSendMsgDialog, false);
            updateField(Fields.currRecordId, null);
            updateField(Fields.recordMail_submitBtn_disabled, false);
            updateField(Fields.recordMail_submitBtn_AsLoading, false);
            updateField(Fields.messageDialog_clearData, false);
            updateField(Fields.currRecordItem, null);
        }
    }

    //======================Request Functions start=====================
    async function fetchPageData(checkBefore = true) {
        const fun = 'fetchPageData:';
        if (!checkBefore || (checkBefore && !isFieldTrue(Fields.isDataFetched))) {
            updateField(Fields.isDataFetched, true);
            try {
                updateField(Fields.isDataFound, false);
                updateField(Fields.isDataLoading, true);
                //extract profile-data
                const profileData = {
                    [mf_pp.name.column]: getUserSessionField(mf_up.fullName.column),
                    [mf_pp.image.column]: getUserSessionField(mf_up.memberImage.column),
                    [mf_pp.role.column]: getDefStr(getUserSessionField(mf_up.memberDesignation1.column), getUserSessionField(mf_up.memberDesignation2.column)),
                };
                updateField(Fields.profileData, profileData);
                log(fun, 'profileData:', profileData);

                const REQUEST_OPTIONS = {};
                sendRequest({
                    reqUrl: ReqUrls.pp__mainPage_fetch_recordList,
                    reqOptions: REQUEST_OPTIONS,
                    onFetched: ((fetchedData) => {
                        log(fun, 'fetchedData:', fetchedData);

                        const recordList = getJsonValueFromNestedKeys(fetchedData, ['data', 'recordList'], []);
                        // log(fun, 'fetchedData.recordList:', recordList);

                        const success = checkNullArr(recordList);
                        updateField(Fields.isDataFound, success);
                        if (success) {
                            // toast(Messages.fetchSuccess, CssVariant.success);success)
                            updateField(Fields.recordList, recordList);
                        } else {
                            updateField(Fields.dataLoadingMsg, Messages.noDataFound);
                            toast(Messages.noDataFound, CssVariant.danger);
                        }
                        updateField(Fields.isDataLoading, false);
                    }),
                    onError: ((error) => {
                        logErr(fun, error);
                        updateField(Fields.isDataLoading, false);
                        updateField(Fields.isDataFound, false);
                        updateField(Fields.dataLoadingMsg, Messages.fetchError);
                    }),
                });
            } catch (error) {
                logErr(fun, error);
                updateField(Fields.isDataLoading, false);
                updateField(Fields.isDataFound, false);
                updateField(Fields.dataLoadingMsg, Messages.fetchError);
            }
        }
    }

    function handleRecordMsgSubmit(formData, recordId) {
        const fun = 'handleRecordMsgSubmit:';
        log(fun, 'formData:', formData, 'recordId:', recordId);
        if (checkNullStr(recordId)) {
            try {
                // const allFieldsChecked = false;
                const allFieldsChecked = true;
                if (allFieldsChecked) {
                    updateField(Fields.recordMail_submitBtn_AsLoading, true);
                    updateField(Fields.recordMail_submitBtn_disabled, true);

                    const REQUEST_OPTIONS = {
                        recordId: recordId, formData: formData,
                    };
                    sendRequest({
                        reqUrl: ReqUrls.msg__mainPage_createMsg,
                        reqOptions: REQUEST_OPTIONS,
                        onFetched: ((fetchedData) => {
                            log(fun, 'fetchedData:', fetchedData);

                            const message = getJsonValue(fetchedData, 'message');
                            const success = isJsonValueTrue(fetchedData, 'success');

                            if (success) {
                                toast(message, CssVariant.success);
                                updateField(Fields.openSendMsgDialog, false);
                                updateField(Fields.currRecordId, null);
                                updateField(Fields.messageDialog_clearData, true);
                                fetchPageData(false);
                            } else {
                                toast(message, CssVariant.danger);
                            }
                            updateField(Fields.recordMail_submitBtn_disabled, false);
                            updateField(Fields.recordMail_submitBtn_AsLoading, false);
                        }),
                        onError: ((error) => {
                            toast("Couldn't send message, please try again!");
                            updateField(Fields.recordMail_submitBtn_AsLoading, false);
                            updateField(Fields.recordMail_submitBtn_disabled, false);
                            logErr(fun, error);
                        }),
                    });
                }
            } catch (error) {
                toast("Couldn't send message, please try again!");
                updateField(Fields.recordMail_submitBtn_AsLoading, false);
                updateField(Fields.recordMail_submitBtn_disabled, false);
                logErr(fun, error);
            }
        } else {
            toast('Record-id not found!', CssVariant.danger);
        }
    }

    //======================Request Functions end=====================

    //======================Util Functions start=====================

    function handleAlphabeticPgntnBtnClick(selectedGroup) {
        const fun = 'handleAlphabeticPgntnBtnClick:';
        try {
            const groupId = selectedGroup.id;
            if (groupId != getField(Fields.alphabeticPagination_currGroupId)) {
                const groupValues = selectedGroup.values;
                // log(fun, 'groupId:', groupId, 'groupValues:', groupValues);
                updateField(Fields.alphabeticPagination_currGroupId, selectedGroup.id);
                startAlphabeticPgntnChangeTransition(() => {

                    let recordList = shuffleList(getRecordList()).reverse();
                    recordList = recordList.map((item) => {
                        // const docNameL = trim(removeNameHonorific(getJsonValue(item, mf_pp.name.column), ' ')).toLowerCase();
                        // const docNameL = trim(removeNameHonorific(getJsonValue(item, mf_up.fullName.column), ' ')).toLowerCase();
                        const docNameL = trim(getJsonValue(item, mf_up.firstName.column) + ' ' + getJsonValue(item, mf_up.lastName.column)).toLowerCase();
                        let filtered = false;
                        for (const letter of groupValues) {
                            filtered = docNameL.startsWith((letter + '').toLowerCase());
                            if (filtered) break;
                        }
                        // log(fun, 'recordList.map.docNameL:', docNameL, 'groupValues.filtered', filtered);
                        return {
                            ...item, filtered: filtered
                        }
                    });
                    // recordList=sortJsonListAdvance(recordList, mf_pp.name.column);
                    // log(fun, 'recordList-updated', recordList);
                    updateField(Fields.recordList, recordList);
                });
            }
        } catch (error) {
            logErr(fun, error);
            toast('Selection failed, please try again', CssVariant.danger);
        }
    }

    function handleRecordVisLimitChange(newLimit) {
        const fun = 'handleRecordVisLimitChange:';
        try {
            // log(fun, 'newLimit:', newLimit);

            // If the current page becomes invalid after changing the record display limit, set it to the last available page
            const newNumPages = Math.ceil(getRecordList().length / newLimit);
            if (getField(Fields.pagination_currPageNum) > newNumPages) {
                updateField(Fields.pagination_currPageNum, newNumPages);
            }
            updateField(Fields.pagination_currPageLimit, newLimit);
        } catch (error) {
            toast('Selection failed, please try again', CssVariant.danger);
            logErr(fun, error);
        }
    }

    function getRecordList(filteredOnly = false) {
        if (checkNullArr(getField(Fields.recordList))) {
            if (isBoolTrue(filteredOnly) && checkNullStr(getField(Fields.alphabeticPagination_currGroupId))) {
                return getField(Fields.recordList).filter(item => isJsonValueTrue(item, 'filtered')).filter(item => checkNullStr(getJsonValue(item, mf_up.fullName.column)));
                // return getField(Fields.recordList);
            } else {
                return getField(Fields.recordList).filter(item => checkNullStr(getJsonValue(item, mf_up.fullName.column)));
            }
        }
        return [];
    }

    function getRecordListToRender() {
        return getRecordList(true).slice((getField(Fields.pagination_currPageNum) - 1) * getField(Fields.pagination_currPageLimit), getField(Fields.pagination_currPageNum) * getField(Fields.pagination_currPageLimit));
    }

    function getProfileData() {
        return checkNullJson(getField(Fields.profileData)) ? getField(Fields.profileData) : {};
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({ ...prevState, [field]: value }));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function toast(text, variant) {
        showToast(text);
        changeToastVariant(variant);
        log(...[text]);
    }

    //const fun ='fun:';
    //log(fun, 'value:',value,'value2;',value2);
    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }

    //======================Util Functions end=====================
});
export default PeerProfilesPage;
